'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimArrayFrom() {
	var polyfill = getPolyfill();

	define(Array, { 'from': polyfill }, {
		'from': function () {
			return Array.from !== polyfill;
		}
	});

	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/array.from/shim.js
 ** module id = 29
 ** module chunks = 0
 **/